export default __webpack_public_path__ + "static/media/chevron-down-solid.155abc7c.svg";